import React from 'react';
import './RoundLoader.css';

const Loader = () => {
  document.title = 'Our Finance';

  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
